import n from "@/lib/n";
import Popup from "@/lib/Popup";
import axios from "axios";

export default class PagePopups
{
    #defaultAttrValue: string|null;
    #blurAttrValue: string|null;

    #attributeNames: { [key: string]: string } = {
        default: 'data-sitesmart-page-popup',
        blur: 'data-sitesmart-page-popup-on-blur',
    };

    constructor()
    {
        this.#defaultAttrValue = n(`body[${this.#attributeNames.default}]`)
            .getAttribute(this.#attributeNames.default);
        this.#blurAttrValue = n(`body[${this.#attributeNames.blur}]`)
            .getAttribute(this.#attributeNames.blur);

        if (this.#defaultAttrValue !== null) {
            this.#initDefault();
        }

        if (this.#blurAttrValue !== null) {
            this.#initBlur();
        }
    }

    #initDefault()
    {
        const popups = this.#getPopupArray(this.#defaultAttrValue as string);
        for (const url of popups) {
            axios.get(url).then((r) => {
                const content = r?.data?.content ?? null;
                const style = r?.data?.style ?? {};
                new Popup({ content }, style);
            }).catch((error) => {
                console.error(error);
            });
        }
    }

    #initBlur()
    {
        const popups = this.#getPopupArray(this.#blurAttrValue as string);
        let timeout = 0;
        let active = false;

        const onLeave = (e: MouseEvent) => {
            if (!active && (e?.target as HTMLElement)?.tagName !== 'SELECT') {
                clearTimeout(timeout);
                active = true;

                for (const url of popups) {
                    axios.get(url).then((r) => {
                        const content = r?.data?.content ?? null;
                        const style = r?.data?.style ?? {};
                        new Popup({ content }, style);
                        timeout = setTimeout(() => {
                            active = false;
                        }, 60000);
                    }).catch((error) => {
                        console.error(error);
                        timeout = setTimeout(() => {
                            active = false;
                        }, 60000);
                    });
                }
            }
        };

        document.documentElement.addEventListener('mouseleave', onLeave);
    }

    #getPopupArray(attributeValue: string): Array<string>
    {
        if (attributeValue.indexOf(';') !== -1) {
            return attributeValue.split(';');
        }
        return [attributeValue];
    }
}
